{
  "title": "Paramètres",
  "nav": "Paramètres",
  "autostart": {
    "title": "Démarrage",
    "label": "Lancer VISION360 à l’ouverture de session",
    "hint": "L’application démarre discrètement dans la zone de notification.",
    "loading": "Lecture du réglage…",
    "error": "Impossible de lire ou de modifier ce réglage.",
    "prompt": {
      "title": "Lancer VISION360 à l’ouverture de session ?",
      "description": "VISION360 démarrera discrètement dans la zone de notification, prêt à répondre à vos raccourcis. Vous pourrez changer d’avis dans les paramètres.",
      "accept": "Oui, lancer au démarrage",
      "decline": "Non merci"
    }
  },
  "hotkeys": {
    "title": "Raccourcis globaux",
    "description": "Ouvrez VISION360 depuis n’importe quelle application.",
    "webOnly": "Les raccourcis globaux sont disponibles dans l’application de bureau.",
    "loading": "Lecture des raccourcis…",
    "error": "Impossible de lire l’état des raccourcis.",
    "binding": "Raccourci",
    "action": "Action",
    "status": "État",
    "active": "Actif",
    "conflict": "Déjà utilisé par une autre application",
    "custom": "personnalisé",
    "change": "Changer",
    "edit": "Modifier",
    "editLabel": "Modifier le raccourci : {{action}}",
    "capturing": "Appuyez sur la nouvelle combinaison… (Échap pour annuler)",
    "saving": "Enregistrement du raccourci…",
    "needsModifier": "Ajoutez Ctrl, Alt, Maj ou Super : une touche seule gênerait la saisie dans les autres applications.",
    "duplicate": "Cette combinaison est déjà attribuée à « {{action}} ».",
    "saveError": "Le raccourci n’a pas pu être enregistré.",
    "reset": "Rétablir les raccourcis par défaut",
    "modes": {
      "spotlight": "Ouvrir la recherche",
      "overlay": "Ouvrir la vue d’ensemble",
      "drawer": "Ouvrir le panneau latéral",
      "wallboard": "Ouvrir le mur d’écrans"
    },
    "wayland": {
      "title": "Wayland : raccourcis gérés par le compositeur",
      "description": "Sous Wayland, une application ne peut pas capturer les touches globales : c’est le compositeur qui s’en charge. Ajoutez ces lignes à votre configuration Hyprland, puis rechargez-la.",
      "x11OptIn": "Préférez-vous que votre compositeur gère tous les raccourcis ? Utilisez cette configuration à la place.",
      "copy": "Copier la configuration",
      "copied": "Configuration copiée",
      "copyFailed": "La copie a échoué. Sélectionnez le texte et copiez-le manuellement."
    }
  }
}
